////// Lib. //////
//////////////////

// ...

///// Utils. /////
//////////////////

// ...

// Event hdls. ///
//////////////////

// ...

///// Assets /////
//////////////////

const msgs = {
  start: ["init. collapsibles"],
  end: ["init. collapsibles", "init. success"],
};

// Method def. ///
//////////////////

export default function init_collapsibles() {
  ///// Setup //////
  //////////////////

  const logs = false;
  if (logs) console.log(msgs.start[0]);

  ///// Action /////
  //////////////////

  const els_collapsibles = document.querySelectorAll("[data-comp='collapsible']");
  els_collapsibles.forEach((el) => {
    const btn = el.querySelector("[data-ref='btn']");
    if (!btn) return;
    btn.addEventListener("click", () => (el.dataset.open = el.dataset.open === "true" ? "false" : "true"));
  });

  //// Conclude ////
  //////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
